import React        from 'react'
import { Label    } from 'sdc-i18n-react'
import { HelpIcon } from 'sdc-cms-help'

export const FieldLabel = ({value,topic,field,uid,as: T = 'th',...props}) =>
<T>
  <Label value={value} {...props} />
  <HelpIcon topic={topic || value} uid={uid}/>
</T>
